// eslint-disable-next-line no-unused-vars
import React from 'react';
import { Card, CardContent, Box, Typography } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { statsCardStyles as sx } from './StatsCard.styles';

/**
 * StatsCard — minimal white card with a tinted icon, big number,
 * optional badge in the top-right corner.
 *
 * Props:
 * - title:        small label below the number
 * - value:        large number
 * - icon:         MUI icon component
 * - color:        one of primary | success | warning | error | info | purple
 *                 (controls icon tint + soft bg)
 * - badge:        { label, tone, withClockIcon } — optional
 *                 tone is one of success | warning | error | neutral
 */
const StatsCard = ({ title, value, icon: IconComponent, color = 'primary', badge }) => (
  <Card sx={sx.card} elevation={0}>
    <CardContent sx={sx.content}>
      <Box sx={sx.topRow}>
        <Box sx={sx.iconBox(color)}>
          {IconComponent && <IconComponent sx={{ fontSize: '1.35rem' }} />}
        </Box>

        {badge?.label && (
          <Box sx={sx.badge(badge.tone)}>
            {badge.withClockIcon && <AccessTimeIcon sx={sx.badgeIcon} />}
            {badge.label}
          </Box>
        )}
      </Box>

      <Typography sx={sx.value}>{value ?? '—'}</Typography>
      <Typography sx={sx.label}>{title}</Typography>
    </CardContent>
  </Card>
);

export default StatsCard;
